import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export function getRedirectUrl(props) {
  const { plugin, akbLoaded } = props;
  const isJiraPlugin = plugin && plugin.app === 'jira';
  const isPartnerHost = isJiraPlugin;
  
  if (isJiraPlugin && isPartnerHost && akbLoaded) {
    return;
  }

  return '/';
}

export default function(ComposedComponent) {
  class RequireAkb extends Component {
    static contextTypes = {
      router: PropTypes.object
    };

    redirect(to) {
      global.window && window.location && window.location.replace(to + window.location.search);
    }

    render() {
      if (this.props.isLoading) {
        return <div></div>;
      }

      const redirectUrl = getRedirectUrl(this.props);
      if (redirectUrl) {
        this.redirect(redirectUrl);
        return null;
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      isLoading: state.auth.isLoading,
      plugin: state.app.plugin,
      akb: state.dashboards.akb,
      akbLoaded: state.dashboards.akbLoaded
    };
  }

  return connect(mapStateToProps)(RequireAkb);
}
